import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Button,
  Card,
  CardContent
} from '@mui/material';
import { Cancel, Home, ArrowBack } from '@mui/icons-material';

const PaymentCancelled: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get('paymentId');

  return (
    <Container maxWidth="md">
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Cancel sx={{ fontSize: 80, color: 'warning.main', mb: 3 }} />
        <Typography variant="h3" gutterBottom fontWeight="bold">
          Payment Cancelled
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
          Your payment was cancelled. No charges have been made to your account.
        </Typography>

        <Card sx={{ mb: 4 }}>
          <CardContent>
            <Typography variant="body1" color="text.secondary">
              If you experienced any issues or would like to complete your payment,
              please try again or contact our support team for assistance.
            </Typography>
          </CardContent>
        </Card>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="outlined"
            size="large"
            startIcon={<ArrowBack />}
            onClick={() => navigate(-1)}
          >
            Go Back
          </Button>
          <Button
            variant="contained"
            size="large"
            startIcon={<Home />}
            onClick={() => navigate('/')}
          >
            Go to Home
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default PaymentCancelled;




